import { ComponentList } from "../app/models/ComponentList";

export const checkComponentActive = (componentList: ComponentList[], componentId: string): boolean => {
    if (!componentList || componentList.length === 0) {
        return false;
    }
    
    const activeComponent = componentList.find((item) => item.id === componentId);
    if (activeComponent) {
        return activeComponent.active;
    }
    
    return false;
};